import { render, staticRenderFns } from "./ModifierGroupComponent.vue?vue&type=template&id=8c0e4b86&"
import script from "./ModifierGroupComponent.vue?vue&type=script&lang=js&"
export * from "./ModifierGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports